module.exports = __webpack_public_path__ + "cover-photo3.28061e40da27ff753d6e.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/BenLeech/portfolio-website/portfolio-website/src/assets/img/cover-photo3.jpg
// module id = ../../../../../src/assets/img/cover-photo3.jpg
// module chunks = 1